import { useExperienceMasterDataApi } from "@/composables/useExperienceMasterDataApi";
import { useQuery } from "@tanstack/vue-query";

export function useHighlightsMasterdataQuery() {
  const experienceMasterDataApi = useExperienceMasterDataApi();
  return useQuery({
    queryKey: ["highlights-masterdata"],
    queryFn: () => experienceMasterDataApi.getPremades("highlights", { language_code: "en" }),
    select: ({ data }) => data,
  });
}
